import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import ARTInteligente from './pages/ARTInteligente';

// Pega o caminho inicial se houver (útil para o preview do Plesk)
const baseName = window.location.pathname.includes('plesk-site-preview') 
  ? '/plesk-site-preview/ipoolcare.com' 
  : '/';

function App() {
return ( <div className="App"> 

<BrowserRouter basename={baseName}> 
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/art-inteligente" element={<ARTInteligente />} />
    {/* Redireciona qualquer rota não encontrada para a Home */}
  <Route path="*" element={<Home />} />
  </Routes>
</BrowserRouter>

 </div>
);
}

export default App;
